/* import __COLOCATED_TEMPLATE__ from './positioning.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

const MIN_PADDING_VALUE = 20;

export default class Positioning extends Component {
  @service intl;
  @service notificationsService;

  @tracked showPaddingError = false;

  validateAndCorrectValue(value, paddingType) {
    let paddingValue = parseInt(value, 10);
    if (!isNaN(paddingValue) && paddingValue < MIN_PADDING_VALUE) {
      this.showPaddingError = true;
      this.notificationsService.notifyError(
        this.intl.t(
          'messenger.look-and-feel-settings.customize.launcher.visibility.position.padding-validation-error',
        ),
      );

      if (paddingType === 'horizontal') {
        this.args.activeBrand.launcherHorizontalPadding = String(MIN_PADDING_VALUE);
        this.args.settings.horizontalPadding = String(MIN_PADDING_VALUE);
      } else if (paddingType === 'vertical') {
        this.args.activeBrand.launcherVerticalPadding = String(MIN_PADDING_VALUE);
        this.args.settings.verticalPadding = String(MIN_PADDING_VALUE);
      }
      return String(MIN_PADDING_VALUE);
    } else {
      this.showPaddingError = false;
      return value;
    }
  }

  get alignmentOptions() {
    return [
      {
        value: 'right',
        text: this.intl.t(
          'messenger.look-and-feel-settings.customize.launcher.visibility.position.right',
        ),
      },
      {
        value: 'left',
        text: this.intl.t(
          'messenger.look-and-feel-settings.customize.launcher.visibility.position.left',
        ),
      },
    ];
  }

  @action
  setAlignment(alignment) {
    this.args.activeBrand.launcherAlignment = alignment;
    if (this.args.activeBrand.isDefault) {
      this.args.settings.alignment = alignment;
    }
  }

  @action
  updateMessengerSettingsHorizontalPadding({ target: { value } }) {
    let correctedValue = this.validateAndCorrectValue(value, 'horizontal');
    if (this.args.activeBrand.isDefault) {
      this.args.settings.horizontalPadding = correctedValue;
    }
  }

  @action
  updateMessengerSettingsVerticalPadding({ target: { value } }) {
    let correctedValue = this.validateAndCorrectValue(value, 'vertical');
    if (this.args.activeBrand.isDefault) {
      this.args.settings.verticalPadding = correctedValue;
    }
  }
}
